(function () {
  'use strict';

  const originalTrigger =
    typeof window.avadaJoyTrigger === 'function' && window.avadaJoyTrigger.__cavernJoyBridge !== true
      ? window.avadaJoyTrigger.bind(window)
      : null;
  const retryLimit = 40;
  const retryDelay = 250;
  const joyLoaderSrc = 'https://static.joy.so/avada-joy.min.js';

  const apiPaths = [
    ['AVADA_JOY', 'open'],
    ['AVADA_JOY', 'show'],
    ['AVADA_JOY', 'widget', 'show'],
    ['AVADA_JOY', 'loyalty', 'open'],
    ['AVADA_JOY', 'loyalty', 'show'],
    ['AVADA_JOY', 'rewards', 'open'],
    ['AVADA_JOY', 'modal', 'open'],
    ['AvadaJoy', 'open'],
    ['avadaJoy', 'open'],
    ['Joy', 'open'],
    ['joy', 'open'],
  ];

  const clickTargets = [
    '#Avada-Joy_FloatingButtonTrigger',
    'button[id*="Avada-Joy"]',
    'button[id*="FloatingButtonTrigger"]',
    '.AvadaJoy-Launcher__Button',
    '.Avada-Joy_ButtonWidget button',
    '[class*="AvadaJoy"][role="button"]',
    '[class*="Avada-Joy"][role="button"]',
    '#joy-ways-to-redeem button',
    '#joy-ways-to-redeem a',
    '[class*="rewards-popup"]',
    '[class*="joy"][class*="launcher"]',
    '[class*="joy"][class*="floating"] button',
    '[class*="joy"][class*="widget"] button',
    '[class*="joy"][class*="button"]',
    '[class*="avada"] button',
    '[class*="Joy"] button',
    '[id*="Joy"] button',
    '[id*="joy"][role="button"]',
    '[class*="joy"][role="button"]',
  ];

  const scrollTargets = [
    '#joy-ways-to-redeem',
    '.earn-vern-apps',
    '.joy-points-calculator__block--embed',
    '[class*="points-calculator"]',
    '[class*="loyalty"]',
    '[id*="joy"]',
    '[class*="joy"]',
  ];

  function valueAtPath(path) {
    return path.reduce((value, key) => (value ? value[key] : undefined), window);
  }

  function isBridgeTrigger(fn) {
    return typeof fn === 'function' && fn.__cavernJoyBridge === true;
  }

  function ensureJoyLoader() {
    if (document.querySelector('script[src*="static.joy.so/avada-joy"]')) {
      return;
    }

    const script = document.createElement('script');
    script.src = joyLoaderSrc;
    script.async = true;
    script.dataset.cavernJoyLoader = 'true';
    document.head.appendChild(script);
  }

  function callFunction(fn, context) {
    try {
      fn.call(context || window);
      return true;
    } catch (error) {
      return false;
    }
  }

  function callKnownApi() {
    const liveTrigger = window.avadaJoyTrigger;

    if (typeof liveTrigger === 'function' && !isBridgeTrigger(liveTrigger) && callFunction(liveTrigger, window)) {
      return true;
    }

    if (originalTrigger && originalTrigger !== window.avadaJoyTrigger && callFunction(originalTrigger, window)) {
      return true;
    }

    for (const path of apiPaths) {
      const fn = valueAtPath(path);
      const context = valueAtPath(path.slice(0, -1));

      if (typeof fn === 'function' && callFunction(fn, context)) {
        return true;
      }
    }

    const joy = window.AVADA_JOY;

    if (joy && typeof joy === 'object') {
      for (const key of Object.keys(joy)) {
        const value = joy[key];

        if (typeof value === 'function' && /^(open|show|toggle)(Widget|Rewards?|Popup|Modal)?$/i.test(key)) {
          if (callFunction(value, joy)) {
            return true;
          }
        }
      }
    }

    return false;
  }

  function isVisible(element) {
    if (!(element instanceof HTMLElement)) {
      return false;
    }

    const rect = element.getBoundingClientRect();
    const style = window.getComputedStyle(element);

    return rect.width > 0 && rect.height > 0 && style.display !== 'none' && style.visibility !== 'hidden';
  }

  function clickKnownTarget() {
    for (const selector of clickTargets) {
      const elements = document.querySelectorAll(selector);

      for (const element of elements) {
        if (!element.closest('[data-joy-redeem]') && isVisible(element)) {
          element.click();
          return true;
        }
      }
    }

    return false;
  }

  function scrollToJoyArea() {
    for (const selector of scrollTargets) {
      const target = document.querySelector(selector);

      if (target && isVisible(target)) {
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return true;
      }
    }

    return false;
  }

  function openJoy(attempt) {
    ensureJoyLoader();

    if (clickKnownTarget() || callKnownApi()) {
      return true;
    }

    if (attempt < retryLimit) {
      window.setTimeout(() => openJoy(attempt + 1), retryDelay);
      return false;
    }

    return scrollToJoyArea();
  }

  function cavernAvadaJoyTrigger(event) {
    if (event && typeof event.preventDefault === 'function') {
      event.preventDefault();
    }

    return openJoy(0);
  }

  cavernAvadaJoyTrigger.__cavernJoyBridge = true;

  if (typeof window.avadaJoyTrigger !== 'function') {
    window.avadaJoyTrigger = cavernAvadaJoyTrigger;
  }

  window.cavernOpenJoy = cavernAvadaJoyTrigger;

  function wireLegacyTriggers(root) {
    const scope = root || document;
    const selector = '[data-joy-redeem], a[href="#joy-ways-to-redeem"], a[href="#joy-rewards"], a[href="#rewards-popup"]';
    const triggers = [
      ...(scope.matches && scope.matches(selector) ? [scope] : []),
      ...scope.querySelectorAll(selector),
    ];

    triggers.forEach((trigger) => {
      trigger.onclick = (event) => {
        event.preventDefault();
        event.stopPropagation();
        cavernAvadaJoyTrigger(event);
        return false;
      };
    });
  }

  document.addEventListener(
    'click',
    (event) => {
      const trigger = event.target.closest(
        '[data-joy-redeem], a[href="#joy-ways-to-redeem"], a[href="#joy-rewards"], a[href="#rewards-popup"]'
      );

      if (!trigger) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      trigger.setAttribute('aria-busy', 'true');
      cavernAvadaJoyTrigger(event);

      window.setTimeout(() => {
        trigger.removeAttribute('aria-busy');
      }, 900);
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => wireLegacyTriggers(document));
  } else {
    wireLegacyTriggers(document);
  }

  window.addEventListener('load', () => wireLegacyTriggers(document));
  window.setTimeout(() => wireLegacyTriggers(document), 1000);

  if ('MutationObserver' in window) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node instanceof HTMLElement) {
            wireLegacyTriggers(node);
          }
        });
      });
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
